import { render } from "./DashboardSummaryCards.vue?vue&type=template&id=4b3e59b2"
import script from "./DashboardSummaryCards.vue?vue&type=script&lang=js"
export * from "./DashboardSummaryCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__